export const APP_NAME = 'BoCoder';
export const APP_ID = 'boclaw';

// 云端编程默认沙箱镜像 —— 后台「编程沙箱」(boclaw-coder) 的 E2B Template ID。
// CodingView 云端模式据此从 /api/cowork/sandbox-images 里挑出编程专用镜像，
// 而不是盲取列表首项（首项可能是 desktop/鲲鹏沙箱）。模板重建 ID 不变；
// 若删除重建模板或改名，更新此处即可，名称兜底（含「编程」/coder/coding）仍会命中。
export const CODING_E2B_TEMPLATE_ID = '94ozh5l6kssbjh4scxyb';
